import React from 'react';
import PropTypes from 'prop-types';
import CertificateCheckModal from './CertificateCheckModal';
import QuestionInfo from './QuestionInfo';
import __ from '../../helpers/translation';

const propTypes = {
  current: PropTypes.object.isRequired,
  removalType: PropTypes.string.isRequired,
  onAnswer: PropTypes.func
};

function QuestionCertification(props) {
    let answer = props.current.answer;
    return (
        <React.Fragment>
            <button className={'btn btn-light'  + (answer && answer.length && answer != '0' ? ' toggled' : '') } 
                data-toggle="modal" data-target="#modalCertificateNumber"
            >
                { __('app.questions.certificate_answer_yes') }
            </button>
            <button className={'btn btn-light'  + (answer == '0' ? ' toggled' : '') } 
                //{... (props.onAnswer ? {onClick: () => props.onAnswer('0') } : {} ) }
                onClick={() => props.onAnswer('0') }
            >
                { __('app.questions.certificate_answer_no') }
            </button>
            <QuestionInfo {... props} />
            
            <CertificateCheckModal 
              removalType={props.removalType} 
              {...props} 
            />
        </React.Fragment>
    );
  
}

QuestionCertification.propTypes = propTypes;

export default QuestionCertification;